import { render, staticRenderFns } from "./BloggerList.vue?vue&type=template&id=002b193a"
import script from "./BloggerList.vue?vue&type=script&lang=js"
export * from "./BloggerList.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports